import { BuyerType } from "@/framework/billing/stripe";
import { TopupTaxPolicy } from "@/framework/billing/topupTaxPolicy";

export type BuyerVatInfo = {
  vatRate: number;
  isReverseCharge: boolean;
};

// VAT that applies to a topup for a buyer. Returns undefined while the country
// is unknown, so callers can say "plus any applicable VAT" instead of guessing.
export function buyerVatInfo(
  buyerType: BuyerType,
  countryCode: string,
): BuyerVatInfo | undefined {
  if (countryCode === "") {
    return undefined;
  }
  const policy = new TopupTaxPolicy({ buyerType, countryCode, amountEur: 0 });
  return { vatRate: policy.vatRate, isReverseCharge: policy.isReverseCharge };
}
